import subscribeForm from './subscribeForm'
export default subscribeForm
